import logdown from 'logdown';
import { SERVICE_NAME } from '../constants';

export default class Logger {
  constructor(moduleName, ...args) {
    this.logger = logdown.apply(this, [
      `${SERVICE_NAME}:${moduleName}`,
      ...args,
    ]);
  }

  log(...msg) {
    this.logger.log(...msg);
  }

  info(...msg) {
    this.logger.info(...msg);
  }

  warn(...msg) {
    this.logger.warn(...msg);
  }

  error(...msg) {
    this.logger.error(...msg);
  }
}
